import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title, Meta, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { ModalGeneralComponent } from 'src/app/shared/components/modal-general/modal-general.component';
import { environment } from 'src/environments/environment';
declare var hbspt: any;
declare var ResizeObserver: any;

@Component({
  selector: 'app-carreras-de-grado',
  templateUrl: './carreras-de-grado.component.html',
  styleUrls: ['./carreras-de-grado.component.scss']
})
export class CarrerasDeGradoComponent implements OnInit {

  datos: any;
  agenda: any;
  items: any[] = [];
  region: any[] = [];
  htmlPlan: string;
  htmlEstudiar: string;
  htmlPerfil: string;
  seccion: any;
  titleLink: any;
  language: any;
  carrer: string;
  venue: string;
  carrertype: string;
  currentRoute: string;
  fare: any[];
  entity: any[];
  formLink: string;
  mySubscription: any;
  linkCode: string;
  numberLettersTitle: number;
  classLettersTitle: string;
  iframe: any;
  carreraTrue: Boolean = true;
  planData: any;
  titlesPlanData: any;
  sedeDeInteres = '';
  apiUrl = environment.apiUrl;
  svgContent: SafeHtml | null = null;
  @ViewChild('cardTitle') cardTitle!: ElementRef;
  @ViewChild('tag') tag!: ElementRef;

  @ViewChild('container') container!: ElementRef;

  // carrerTypes = ["maestria", "profesorado", "carrera-corta", "pregrado", "posgrado", "ciclo-de-licenciatura", "tecnicatura", "carrera-de-grado", "doctorado", "postitulo", "curso-de-posgrado", "curso-online", "especializacion", "posgrado-online"];
  constructor(private _sanitizer: DomSanitizer, public dialog: MatDialog,
    private aRouter: ActivatedRoute, public route: ActivatedRoute,
    public carrerService: GeneralService, private router: Router, public title: Title, public meta: Meta, private el: ElementRef) {
    this.route.params.forEach((params: Params) => {
      this.carrer = params['carrer'];
    });
    this.route.params.forEach((params: Params) => {
      this.venue = params['venue'];
    });
    let careerText = (this.carrer.charAt(0).toUpperCase() + this.carrer.slice(1)).replace(/-/g, " ");
    let venueText = (this.venue.charAt(0).toUpperCase() + this.venue.slice(1)).replace(/-/g, " ");

    this.title.setTitle('UCA - ' + careerText + ' (' + venueText + ')');
    this.meta.addTag({ property: 'og:title', content: 'UCA - ' + careerText + ' (' + venueText + ')' }, true);
    this.meta.addTag({ property: 'og:description', content: '' }, true);
    this.route.params.forEach((params: Params) => {
      this.carrertype = params['type'];
      /*if (!this.carrerTypes.includes(this.carrertype)) {
        router.navigate(['404']);
      }*/
    });
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
    });

    this.currentRoute = `/${this.language}/facultades/${this.venue}/${this.carrertype}/${this.carrer}`;


    this.aRouter.params.forEach((params: Params) => {
      this.language = params['language'];
      this.titleLink = params['title'];

    });
    this.seccion = this.aRouter.snapshot.params['seccion']
    this.carrerService.getCarrerByTitle(this.carrer, this.venue, this.language).subscribe(data => {
      if ((data.data[0][0] == "career_disabled")) {
        router.navigate(['404']);
      } else
        if (data.data) {
          this.sedeDeInteres = this.route.snapshot.queryParamMap.get('sede_de_interes');

          this.agregarParametro(data.data[0].region, data.data[0].title)
          this.titlesPlanData = data.data[0].studyPlan[0]
          this.datos = data.data[0];
          var i = 0;

          this.datos.region.forEach(element => {
            i++;
            element.link = this.language + element.link;
            if (this.datos.region[i]) {
              element.title = element.title + ' |\u00A0';
            }
            this.region.push(element)
          });
          this.htmlEstudiar = this.datos.whyStudy;
          this.agenda = this.datos.event
          this.linkCode = this.datos.linkCode;
          this.iframe = this.getVideoIframe(this.linkCode);
          this.planData = this.datos.studyPlanItems.map(item => {
            const titulo = item.title.trim();
            return {
              ...item,
              title: titulo.charAt(0).toUpperCase() + titulo.slice(1).toLowerCase()
            };
          });

        } else {
          router.navigate(['404']);
        }

    })

    this.carrerService.getCarreraProfileTitle(this.carrer).subscribe(profile => {
      if (profile.data[0]) {
        this.htmlPerfil = profile.data[0]["profileTitleScope"];
      }
    })


  }
  agregarParametro(sedes: any[], carrera: string) {
    const queryParams: { [key: string]: any } = {
      sede_de_interes: this.sedeDeInteres || sedes[0].title,
    };

    sedes.forEach(s => {
      const sedeFormateada = this.quitarTildes(s.title.toLowerCase().replace(/\s+/g, '_'));
      const plural = (sedeFormateada === 'rosario') ? '' : 's';
      const dynamicPropertyName = `carrera${plural}_de_grado__${sedeFormateada}_`;
      queryParams[dynamicPropertyName] = carrera;
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
    }).then(() => {
      // 🔁 recargar el formulario después de actualizar los parámetros
      this.formLoaded = false;
      setTimeout(() => this.cargarFormulario(), 300);
    });
  }
  quitarTildes(texto: string) {
    const tildes = {
      á: 'a',
      é: 'e',
      í: 'i',
      ó: 'o',
      ú: 'u',
      ü: 'u',
      Á: 'A',
      É: 'E',
      Í: 'I',
      Ó: 'O',
      Ú: 'U',
      Ü: 'U',
    };

    return texto.replace(/[áéíóúüÁÉÍÓÚÜ]/g, letra => tildes[letra]);
  }
  isDesktop = false;
  ngOnInit(): void {
    this.checkStyles();
  }

  ngAfterContentInit() {
    this.checkStyles();

  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkStyles();
  }
  resizeObserver: any;
  ignoreNextResize = false;

  ngAfterViewInit(): void {
    if (this.container?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.ignoreNextResize) {
          this.ignoreNextResize = false;
          return;
        }
        this.checkStyles();
      });
      this.resizeObserver.observe(this.container.nativeElement);
    }

    setTimeout(() => this.cargarFormulario(), 0);

  }
  private formLoaded = false;

  cargarFormulario() {
    const contenedor = document.getElementById('hubspot-form');
    if (!contenedor) return;

    // Evita cargarlo dos veces
    if (this.formLoaded) return;
    this.formLoaded = true;

    /*hbspt.forms.create({
      region: "na1",
      portalId: "23647426",
      formId: "b2e6899b-83b4-4a49-92ff-92360afdd10d",
      target: '#hubspot-form'
    });*/
  }
  checkStyles() {
    if (this.datos) {

      var sectionPrimary = document.getElementById("section-primary-uno");
      var titleSection = document.getElementById("title-section");
      var banner1 = document.getElementById("banner-inscripcion");
      var banner3 = document.getElementById("banner3");

      if (sectionPrimary != null && titleSection != null &&
        sectionPrimary != null && banner1 != null) {
        let desktopBig = window.innerWidth > 1440;
        let desktop = window.innerWidth > 768;
        let mobBig = window.innerWidth < 768;
        let mob = window.innerWidth < 481;

        if (banner1) {
          this.datos.general_data_obj.banner_button_text_size = 18; //font-size btn
          let banner1Heigth = banner1.offsetHeight;

          var banner1Texto1 = document.getElementById("banner1-texto1");
          var banner1Texto2 = document.getElementById("banner1-texto2");
          var bannerBtn1 = document.getElementById("banner-btn-1");

          // Calcular tamaños finales (ya responsivos)
          var banner1Texto1Size = this.getResponsiveSizeBanner1(this.datos.general_data_obj.banner_text_font_size);
          var banner1Texto2Size = this.getResponsiveSizeBanner1(this.datos.general_data_obj.banner_subtitle_font_size);
          var bannerBtn1Size = this.getResponsiveSizeBanner1(this.datos.general_data_obj.banner_button_text_size);

          // Asignar font-size
          banner1Texto1.style.fontSize = banner1Texto1Size + "px";
          banner1Texto2.style.fontSize = banner1Texto2Size + "px";
          bannerBtn1.style.fontSize = bannerBtn1Size + "px";

          // Asignar line-height relativo al tamaño final
          banner1Texto1.style.lineHeight = banner1Texto1Size * 1.3 + "px";
          banner1Texto2.style.lineHeight = banner1Texto2Size * 1.4 + "px";
          bannerBtn1.style.minHeight = (desktopBig) ? banner1Heigth * 0.18 + "px" : (desktop) ? banner1Heigth * 0.19 + "px" : (mob) ? banner1Heigth * 0.1 + "px" : banner1Heigth * 0.12 + "px";


        }
        if (banner3) {

          this.datos.general_data_obj.banner_tres_button_text_size = 40;//font-size btn

          let banner3Heigth = banner3.offsetHeight;

          var banner3Texto1 = document.getElementById("banner3-texto1");
          var banner3Texto2 = document.getElementById("banner3-texto2");
          var banner3Texto3 = document.getElementById("banner3-texto3");
          var banner3Btn1 = document.getElementById("banner3-btn-1");

          // Calcular tamaños finales (ya responsivos)
          var banner3Texto1Size = this.getResponsiveSizeBanner3(this.datos.general_data_obj.banner_tres_title_font_size);
          var banner3Texto2Size = this.getResponsiveSizeBanner3(this.datos.general_data_obj.banner_tres_text_font_size);
          var banner3Texto3Size = this.getResponsiveSizeBanner3(this.datos.general_data_obj.banner_tres_text_dos_font_size);
          var banner3Btn1Size = this.getResponsiveSizeBanner3(this.datos.general_data_obj.banner_tres_button_text_size);

          // Asignar font-size
          banner3Texto1.style.fontSize = banner3Texto1Size + "px";
          banner3Texto2.style.fontSize = banner3Texto2Size + "px";
          banner3Texto3.style.fontSize = banner3Texto3Size + "px";
          banner3Btn1.style.fontSize = banner3Btn1Size + "px";

          // Asignar line-height relativo al tamaño final
          banner3Texto1.style.lineHeight = banner3Texto1Size * 1.08 + "px";
          banner3Texto2.style.lineHeight = banner3Texto2Size * 1.10 + "px";
          banner3Texto3.style.lineHeight = banner3Texto3Size * 1.08 + "px";

          banner3Btn1.style.height = (desktop || desktopBig) ? banner3Heigth * 0.26 + "px" : (mob) ? banner3Heigth * 0.1 + "px" : banner3Heigth * 0.12 + "px";

        }
      }


    }
  }

  getResponsiveSizeBanner1(base: any): any {
    const width = window.innerWidth;
    const size = parseInt(base);

    if (width >= 1920) return size;
    if (width >= 768) {
      const maxWidth = 1920;
      const minWidth = 768;
      const baseFactor = 0.3;
      const factor = baseFactor + (width - minWidth) / (maxWidth - minWidth) * (1 - baseFactor);
      return size * factor;
    }
    if (width >= 480) {
      const maxWidth = 768;
      const minWidth = 360;
      const baseFactor = 0.5;
      const factor = baseFactor + (width - minWidth) / (maxWidth - minWidth) * (1 - baseFactor);
      return size * factor;
    }
    return size * 0.4;
  }

  getResponsiveSizeBanner3(base: any): any {
    const width = window.innerWidth;
    const size = parseInt(base);

    if (width >= 1920) return size;
    if (width >= 768) {

      const maxWidth = 1920;
      const minWidth = 768;
      const baseFactor = 0.3;
      const factor = baseFactor + (width - minWidth) / (maxWidth - minWidth) * (1 - baseFactor);
      return size * factor;
    }
    if (width >= 480) {
      const maxWidth = 767;
      const minWidth = 360;
      const baseFactor = 0.15;
      const factor = baseFactor + (width - minWidth) / (maxWidth - minWidth) * (1 - baseFactor);
      return size * factor;
    }

    return size * 0.5;
  }



  openModal(id: string) {
    if (id == 'htmlEstudiar') {
      this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: this.htmlEstudiar, title: '¿Por qué estudiar en la UCA?' } });
    }
  }
  getVideoIframe(url) {
    if (url) {
      var video, results;

      if (url === null) {
        return '';
      }
      results = url.match('[\\?&]v=([^&#]*)');
      video = (results === null) ? url : results[1];

      return this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + video + '?disablekb=0&rel=0');
    }
  }


  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    const contenedor = document.getElementById('hubspot-form');
    if (contenedor) contenedor.innerHTML = '';
  }



  
}
